// // API Configuration
export const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/banking-crm/banckcrmbackend/api" // <- Updated to your new folder name
    : "/API/api"; // <- Using relative path prevents ERR_NAME_NOT_RESOLVED and DNS errors!

// Create a fetch wrapper for API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const defaultOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    console.log('🌐 API Request:', { endpoint, url, method: config.method });
    
    const response = await fetch(url, config);
    
    console.log('📡 API Response Status:', response.status);
    
    // Check if response is ok
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error('❌ API returned error:', { status: response.status, errorData });
      throw new Error(errorData.message || `API Error: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ API Response Data:', data);
    
    // Handle both response formats
    // Format 1: { success: true, data: { token, user } }
    // Format 2: { token, user, success: true }
    const responseData = data.data || data;
    
    if (data.success === false) {
      console.error('❌ API returned success: false', data);
      return { success: false, error: data.message || data.error || 'API request failed' };
    }
    
    return { success: true, data: responseData };
  } catch (error) {
    // Better error messages for debugging
    let errorMessage = error.message;
    
    if (error.message.includes('Failed to fetch')) {
      errorMessage = `Cannot reach API server. Make sure the backend is running at ${API_BASE_URL}`;
    } else if (error.message.includes('CORS')) {
      errorMessage = 'CORS Error: Backend needs to allow requests from this origin. Contact your administrator.';
    }
    
    console.error('🔴 API Exception:', { 
      error: error.message, 
      url, 
      errorMessage 
    });
    return { success: false, error: errorMessage };
  }
};
